module.exports = __webpack_public_path__ + "img/reports_icon.595b9d34.svg";